module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "height": "0pt"
    },
    attrs: {
      "id": "id_Toc39728743"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_114",
    attrs: {
      "id": "id_Toc146373209"
    }
  }, [_c('span', {
    staticClass: "text_"
  }, [_vm._v("Chapter Three"), _c('br', {}), _vm._v("Friends Rock")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("My stomach sank at the sight of school; those tall gates were like jaws that slammed us in. I pulled my jacket tighter over my shoulders and closed my eyes. It smelt like freshly cut grass on a hot summer’s day, and right before a storm, and when you’re sitting by a fire with hot chocolate, and there are arms around you, and you don’t have anything to do, or anywhere to be. If that were a smell.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I moved the jacket collar away from my nose and began walking. Stephan, in his cool sunglasses, bounced around in front of his friends. There were five of them, all were perched against a stone bench, and snickering as I passed. I became strongly aware of my shoelaces being undone, and how the frayed bottoms of my pants were joining the flicking laces, flapping about with every step.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Guess what’s coming?” I could hear him saying theatrically, “the mute mutant.” He knelt on one knee and waved a pointed arm in my direction. The sound of their rumbling laughter chewed at my heartstrings; the teeth of the gate joining in for fun. I hunched and trotted forward quietly wishing to be spat out.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Hey,” Josh came over and looked at Stephan and his gang laughing. “What’s happening?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Don’t worry about it, I’m fine.” I begged with my eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“No, you’re not.” He stood in my way.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Come on, we’re just having a bit of fun.” Stephan came up to me and gave me a friendly pat on the back.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Yeah, I think you and ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("Christina")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" have somewhere else to go and have fun.” A glint of excitement in his eye, a lust for confrontation, Josh stood tall while I lowered myself.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Christina sat with a salon-fabulous glow, her leg crossed over her knee, and two red pointed shoes sparkling up at me. My jaw tightened as our eyes met. ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("As if")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" I would stand here waiting for her to step up for me. ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("As if")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v("—but of course—I froze, my feet unmoving as they all watched and waited for my reaction.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Josh dropped his backpack and took a step towards the group. “Let’s go, you and me, right now!”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Pffft…yeah right, I’m not fighting you over ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("that")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v("!” Stephan nodded in my direction. My head started thumping, a throbbing across my chest and collarbone worried me. My left shoulder started to hurt as well, and I swallowed a hard lump in my throat.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Josh turned to look at Christina directly. “You’re all a bunch of jackasses.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Oh please.” She eased her glossy lips into a cool grin. “Just take your stupid bookend of a face and drag your knuckles around a different slice of the yard. We aren’t interested.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("To my surprise, Josh smiled too. “C’mon, let’s go to class.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I didn’t have to look at her to know she wasn’t going to be talking to me for a while. I wobbled away and slipped my hands deep into my pockets. I felt the corners of my eyes sting. I wished that I could just go hide away, somewhere no one would ever need to see me again. Unfortunately, my school desk was not deep enough to crawl and hide under.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“You look really sad.” I nearly started to cry as he reached out and placed a tender hand over my shoulder. “Can I photograph you right now?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I slammed my book down. “No.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“You would make a great portrait for my collection right now,” he said. “It will only take a second.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Don’t,” I mustered with clenched fists.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Fine.” He flipped up the collar of his shirt and leaned over my desk. “What do you want to do then? What’s ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("safe ")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v("to discuss? What doesn’t upset you these days? Rocks?” He pointed outside the window and lowered his voice as a teacher entered the room. “Rocks aren’t upsetting you, are they? Do I need to be more sensitive about them now, too?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I stared at the cover of my workbook until he went to his own seat. The teacher began his lecture, something about something. I scribbled into my notebook and curled my arm across the top of the page so no one could see.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_7"
  }, [_vm._v("What does Christina have in common with a rock?")])]), _vm._v(" "), _c('ol', {
    staticClass: "list_"
  }, [_c('li', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_7"
  }, [_vm._v("The rock and Christina both won’t listen to me.")])]), _vm._v(" "), _c('li', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_7"
  }, [_vm._v("Neither of them will visit me.")])]), _vm._v(" "), _c('li', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_7"
  }, [_vm._v("The rock has never invited me to their birthday party.")])]), _vm._v(" "), _c('li', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_7"
  }, [_vm._v("They both don’t care if I’m sad or lonely.")])]), _vm._v(" "), _c('li', {
    staticClass: "block_19"
  }, [_c('span', {
    staticClass: "text_7"
  }, [_vm._v("Both of them wouldn’t walk down the corridors with me unless I carried and dragged them.")])])]), _vm._v(" "), _c('p', {
    staticClass: "block_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“My best friend may as well be a rock,” I muttered to myself. “Some people have pet rocks; some people have friend-rocks.” I spun in my seat and looked Josh square in the eye. “Say whatever you want, I don’t care about rocks and I don’t care about anything else either.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Hope Rowana!” I jumped. “Can you tell the class what homework you completed last night?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I—I didn’t know we had homework.” I gripped the sides of my desk.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“So, you haven’t completed anything?” I dug harder.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“No, I’m sorry.” I shook my head and felt my ears turn red as the room snickered.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“That’s right, ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("you")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" wouldn’t have.” He walked over and placed a sheet of paper on my desk. “Because I haven’t given you the homework yet.” I could see the smirk form across his lips as I churned in my seat. The hand on the clock ticked slowly for the remainder of the lesson. I sat with glazed eyes and squeezed my wrists for relief.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("When the bell rang, I rushed for the bathroom and bit down hard on my tongue. I remembered one time a health teacher informed me that if I swallowed large mouthfuls of food too often, it would stretch out my throat, and my tongue would become loose and it would fall down into the back of my throat, and I would choke on it and die.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I spent many weeks only eating nibbles of food. I would bite down on my tongue every time I swallowed. Eventually, someone noticed. I had been compulsive, so it was red raw, and there was a big meeting in the principal’s office about it. The health teacher insisted that I had made it all up, that I was a ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("liar")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(" who was just trying to get attention, and everyone rushed to believe her so quickly I wanted to cry.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Except for Josh, he believed me. He said he’d overheard what had happened and thought it was super interesting and wanted to meet me and become my friend. He wanted to photograph my tongue as well, and I let him, because it was so nice to be believed by someone. He promised me he wouldn’t tell anyone about it and gifted me the pink blotchy picture.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("He reassured me too that I couldn’t stretch out my throat, or swallow my tongue, no matter what I did. I was so grateful to be befriended by an older boy. It didn’t matter if they had kept him back a few grades either. I was sure he was smart enough to know about tongues. He was able to recite all the scientific elements, knew practically everything about history, and even worked out my birthday before I told it to him.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I let go of my tongue and emerged from the toilet cubicle slowly. My breath was erratic and quickened as I made my way to the school nurse. If I could just be sent home, I would go to the park and lay on the benches. I would close my eyes and listen to the water trickle from the fountain, and the birds chirping, while I wrap myself into Zack’s jacket.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("My hand paused on the door handle as familiar voices argued on the other side.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“You can’t keep wasting your time with him,” I heard Josh speak first. “We’ve been through this whole bullying thing before.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“That’s stupid; he has real feelings for me.” Christina sounded riled, and I imagined her arms crossed with her red heel tapping away impatiently.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“It’s Stephan, he has feelings for your tits, sweetie.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Screw you! Just because you’re the one stuck with her—”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I get the most time because I’m best for the job,” he said. “I’m trying to get information, deeper insight, and you’re thinking about sex.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Nathan is never going to see you as his equal.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I stepped away from the door as it swung open. Josh emerged, shaking his head, and didn’t even notice that I was there. I followed him outside. He kicked a rock and tossed his camera over his neck so that it bounced on his backpack with each stride.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Josh! Wait!” I jogged to catch up.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“What are you doing out of class?” Josh looked around as if trying to find a physical reason why I had ditched.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I felt sick. I heard you in the health room.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“What?” He frowned.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I wasn’t—I mean, I was going to see the nurse and I heard you and Christina talking.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“And?” He reached around for his camera and clutched onto it tightly.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Well, it just seemed like you two were arguing, and I know you stood up for me this morning, but then we were fighting as well afterwards.” I waited ten seconds for him to say anything at all. “You didn’t have to talk to her for me, that’s all.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Josh’s light-brown eyes were intensely looking me over. I wasn’t sure how to feel until he smiled and shrugged. “You and Christina have been friends for a while, I wanted to make things right.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“You don’t need to.” I pursed my lips. “Who’s Nathan?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“What do you mean?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“I heard her mention his name.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("He crossed his arms over his chest defensively. “You know, I’ve done a lot for you today and all you can do is be nosy and ask a million questions. How about saying ‘thank you,’ for once? All I want is to spend more time with you, that’s all I’ve asked for.” He clicked on the camera repetitively. “Are you coming over to my house later, or not?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I pulled my sleeves down over my palms and shoved my hands deep into my pockets.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Forget it—”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“You want me to visit.” I closed my eyes tightly for a second. “But you mean sleepover, don’t you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Yes.” He raised an eyebrow. “Don’t make this weird, Hope, we aren’t in primary school anymore.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Okay,” I mumbled.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“What?” He squinted down at me and I sigh, averting my gaze.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Okay, I’ll do it. On the weekend.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Josh jumped happily and grabbed my elbow. He squeezed to bring me closer and whispered, “I’m sure I can do all the things you like.” The camera swung over his shoulder and he waltzed back into the hallway. I felt heat between my thighs—Red. Hot. Shame. I clutched the straps of my backpack and followed him in.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("We were late for drama class. I sat next to Josh like usual, firmly holding my knees together. I heard a familiar click as Josh took pictures of my notes. He often did this to avoid having to hand-write information. Nobody seemed to mind or care.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("I flinched as he tilted the camera up slightly. “Please don’t.” I moved as far away from my notebook as possible.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Hope, you’ve been photographed before for school pictures and that time with your tongue. It’s not as scary as you keep saying it is; ")]), _c('span', {
    staticClass: "text_7"
  }, [_vm._v("nothing happened to you")]), _c('span', {
    staticClass: "text_6"
  }, [_vm._v(".” He shook his head and continued, “how can one girl be so generally afraid of everything, and not terribly afraid of anything, all at once?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“What does that even mean?” I squirmed in my seat and tugged my hands underneath the desk. “I’m afraid of specific things. I’m afraid of falling off a cliff.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Really?” He raised his eyebrows. “Because we went rock climbing before, and you were fine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("“Yeah, but I was scared for some of it. I even slipped and—what are we even talking about?”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("He shrugged. “I just think you are scared of all the wrong things sometimes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "block_18"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("Soon it was home time. I left awkwardly, barely saying goodbye. I considered skipping the return home altogether, or at least waiting until everyone had gone to sleep—but Christina wouldn’t have me, and the weather looked dreary. So, I went on my way and wished for the best.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_c('span', {
    staticClass: "text_3"
  }, [_c('br', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_11"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b3a2044","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_007.vue
// module id = 84
// module chunks = 0